module.exports = __webpack_public_path__ + "img/haircut-mobile.244fcdd3.svg";